	$('.carousel').carousel({
	  interval: 5000,
   	  pause: "false"
	});
	$(document).ready(function(){
$('.navbar-toggler').click(function(){
$('.navbar-toggler').toggleClass('showtoggle');
});	
});	
$(document).ready(function(){
$('.header__search').click(function(){
$('.search-modal').toggleClass('showtoggle');
});	
});	
$(document).ready(function(){
$('.modal__close-button').click(function(){
$('.search-modal').removeClass('showtoggle');
});	
});	
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 30) {
        $(".header_sec").addClass("fixed");
    } else {
        $(".header_sec").removeClass("fixed");
    }
});


$(document).ready(function() {
  var owl = $('.shopcollect_sec .owl-carousel');
  owl.owlCarousel({
    margin: 10,
    nav: true,
    loop: true,
    dotsEach: false,
    autoplay: true,
    responsive: {
      0:{
      	items: 2,       
      },
	  575: {
	    items: 2,
	  },
      600: {
        items: 3,       
      },
      768: {
        items: 4,        
      },
      992: {
        items: 5,       
      },
      1200: {
        items: 6,
      }
    }
  });
});
$(document).ready(function() {
  var owl = $('.arrivals_sec .owl-carousel');
  owl.owlCarousel({
    margin: 10,
    nav: true,
    loop: true,
    dotsEach: false,
    responsive: {
      0:{
      	items: 1,  
      	autoplay:true,     
      },
      460:{
      	items: 2,  
      	autoplay:true,     
      },
	  575: {
	    items: 3,
	    autoplay:true, 
	  },
      992: {
        items: 3,
        autoplay:true,    
      },
      1200: {
        items: 3,
        touchDrag: false,
        mouseDrag: false
      }
    }
  });
});


$(document).ready(function() {
  var owl = $('.shopstone_sec .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    nav: true,
    loop: true,
    dotsEach: false,
    autoplay: true,
    mouseDrag: true, 
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    slideSpeed: 300,
    responsive: {
      0:{
      	items: 1,       
      },
	  575: {
	    items: 1,
	  },
      600: {
        items: 1,       
      },
      768: {
        items: 1,        
      },
      992: {
        items: 1,       
      },
      1200: {
        items: 1
      }
    }
  });
});
$(document).ready(function() {
  var owl = $('.home_blog_sec .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    nav: false,
    loop: true,
    dotsEach: false,
    autoplay: false,
    mouseDrag: true, 
    responsive: {
      0:{
      	items: 1,       
      },
	  575: {
	    items: 1,
	  },
      600: {
        items: 2,       
      },
      768: {
        items: 2,        
      },
      992: {
        items: 3,       
      },
      1500: {
        items: 4
      }
    }
  });
});
$(document).ready(function() {
  var owl = $('.badges_sec .owl-carousel');
  owl.owlCarousel({
    margin: 20,
    nav: true,
    loop: true,
    dotsEach: false,
    autoplay: false,
    mouseDrag: true, 
    responsive: {
      0:{
      	items: 1,
        margin: 10,
      },
	  575: {
	    items: 1,
        margin: 10,
	  },
      600: {
        items: 2,   
        margin: 10,
      },
      768: {
        items: 3,  
        margin: 10,
      },
      992: {
        items: 3,       
      },
      1200: {
        items: 4
      }
    }
  });
});

$(document).ready(function() {
  var owl = $('.assurance_sec .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    nav: true,
    loop: true,
    dotsEach: false,
    autoplay: false,
    responsive: {
      0:{
      	items: 1,     
      	autoplay: true   
      },
	  575: {
	    items: 2,
	    autoplay: true 
	  },
      600: {
        items: 3,  
        autoplay: true      
      },
      768: {
        items: 4,  
        autoplay: true       
      },
      992: {
        items: 6,
        autoplay: true       
      },
      1200: {
        items: 8
      }
    }
  });
});

$(document).ready(function() {
  var owl = $('.alsolike_sec .owl-carousel');
  owl.owlCarousel({
    margin: 30,
    nav: true,
    loop: true,
    dotsEach: false,
    autoplay: false,
    responsive: {
      0:{
      	items: 1,       
      },
	  575: {
	    items: 1,
	  },
      600: {
        items: 2,       
      },
      768: {
        items: 2,        
      },
      992: {
        items: 2,       
      },
      1200: {
        items: 3
      }
    }
  });
});
$(document).ready(function() {
  var owl = $('.bestseller_sec .owl-carousel');
  owl.owlCarousel({
    margin: 0,
    nav: true,
    loop: true,
    autoplay:true,
    dotsEach: false,
    responsive: {
      0:{
      	items: 1,       
      },
	  576: {
	    items: 2,
	  },
      992: {
        items: 3,       
      },
      1200: {
        items: 4,
      }
    }
  });
});
$(document).ready(function() {
    $(".tab_menu a").click(function(event) {
        event.preventDefault();
        $(this).parent().addClass("actv");
        $(this).parent().siblings().removeClass("actv");
        var tab = $(this).attr("href");
        $(".tab-content").not(tab).css("display", "none");
        $(tab).fadeIn();
    });
});
